import Vue from "vue";
import { rateCost } from '@/model/javaApi/detail.js'
import { combination } from '@/utils/regular.js'
import { store } from '@/observable/store'
import { getAppClient } from '@/utils/commonUtils'
import router from '@/router/router'
import { toApp } from '@/utils/appBridge'

const InsurStore = Vue.observable({
    //保险信息
    insurance: {},
    //填单页信息
    insuranceform: {
        schemes: [], //附加服务
        costRateInfo: {}, //算费结果
        fillExplain: "",    //提示信息
        isShowFee: false, //是否展示费率表
        materielMap: [],//协议条款
        modules: [], // 信息模块
        payMethod: {}, //缴费方式
        productCode: '',//商品code
        serviceButton: '',//客服
    },
    // 算费因子得到的算费结果
    resultCount: {
        selectItems: [], //附加服务价格
        price: '--',  //付费价格
        premiumList: [], //保费列表
    },
    // 投被保人关系 1本人 2父母 3配偶 4子女
    relationship: null,
    // 被保人对应的信息
    relationshipInfo: {
        1: {},
        2: {},
        3: {},
        4: {}
    },
    // 填单页面参数汇总
    fromPageData: {},
});

const
    InsurMutations = {
        // 重置必要的全局状态
        resetState() {
            InsurStore.insuranceform = {
                schemes: [], //附加服务
                costRateInfo: {}, //算费结果
                fillExplain: "",    //提示信息
                isShowFee: false, //是否展示费率表
                materielMap: [],//协议条款
                modules: [], // 信息模块
                payMethod: {}, //缴费方式
                productCode: '',//商品code
                serviceButton: '',//客服
            };
            InsurStore.resultCount = {
                selectItems: [], //附加服务价格
                price: '--',  //付费价格
                premiumList: [], //保费列表
            };
            InsurStore.relationship = null;
            InsurStore.fromPageData = {};
            InsurStore.relationshipInfo = {
                1: {},
                2: {},
                3: {},
                4: {}
            };
        },
        // 保险信息存储 
        insurance(parme) {
            const newData = parme;
            InsurStore.insurance = newData

        },
        // 填单页信息存储
        insuranceform(parme) {
            const newData = parme;
            InsurStore.insuranceform = newData
            InsurMutations.resultCountReset(parme.costRateInfo)
            // 新进入填单页时 投被保人关系置空
            InsurStore.relationship = null
        },

        // 试算结果格式调整并存储
        resultCountReset(res) {
            if (res) {
                // 保费列表 格式调整
                let list = [];
                res.firstPremium ? list.push({ optionName: "首月保费", optionPrice: res.firstPremium }) : ''
                res.secondPremium ? list.push({ optionName: "次月保费", optionPrice: res.secondPremium }) : ''
                res.subsequentPremium ? list.push({ optionName: "后续保费", optionPrice: res.subsequentPremium }) : ''
                if (!res.firstPremium && !res.secondPremium && !res.subsequentPremium) {
                    res.followDelivery ? list.push({ optionName: "保费", optionPrice: res.followDelivery }) : ''
                }
                InsurStore.resultCount = res;
                // 合并 选中的附加服务
                InsurStore.resultCount.premiumList = res.selectItems.length ? list.concat(res.selectItems) : list;
            }
        },

        // 规则校验
        rules(rule = {}, value = '') {
            if (value.length > 0) {
                const result = combination(rule.inputLimit, value);
                if (result && !(value.length - rule.max > 0)) {
                    return true
                } else {
                    return false
                }
            } else {
                return true
            }
        },
    };


export {
    InsurStore,
    InsurMutations
}